// components/products/ProductRow.tsx
import { Package, DollarSign, Tag, Eye } from "lucide-react";
import TableRow from "../../ui/TableRow";
import { Product } from "@cabukaka/types";

interface ProductRowProps {
  product: Product;
  onAction: (product: Product) => void;
  onSelect?: (product: Product, isSelected: boolean) => void;
  isSelected?: boolean;
  selectable?: boolean;
}

export default function ProductRow({ 
  product, 
  onAction, 
  onSelect,
  isSelected = false,
  selectable = false
}: ProductRowProps) {
  return (
    <TableRow
      item={product}
      onAction={onAction}
      onSelect={onSelect}
      isSelected={isSelected}
      selectable={selectable}
      actionable={true}
    >
      {/* Colonne Produit - toujours visible */}
      <td className="py-3 px-4">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 rounded-lg bg-gray-100 flex items-center justify-center overflow-hidden flex-shrink-0">
            {product.mainImage ? (
              <img src={product.mainImage} alt={product.name} className="w-full h-full object-cover" />
            ) : (
              <Package size={18} className="text-gray-400" />
            )}
          </div>
          <div>
            <span className="font-medium text-gray-800 block line-clamp-1">
              {product.name}
            </span>
            {product.shop && (
              <span className="text-xs text-gray-500">{product.shop.name}</span>
            )}
          </div>
        </div>
      </td>

      {/* Colonne Prix - cachée sur mobile */}
      <td className="hidden sm:table-cell py-3 px-4">
        <div className="flex items-center gap-2">
          <DollarSign size={14} className="text-gray-400" />
          <span className="text-gray-600 font-medium">{product.priceLabel}</span>
        </div>
      </td>

      {/* Colonne Stock - cachée sur mobile */}
      <td className="hidden sm:table-cell py-3 px-4">
        <span className={`inline-flex px-2 py-1 text-xs rounded-full ${product.inStock ? 'bg-emerald-100 text-emerald-700' : 'bg-red-100 text-red-700'}`}>
          {product.inStock ? 'En stock' : 'Rupture'}
        </span>
      </td>

      {/* Colonne Catégorie - cachée sur tablette */}
      <td className="hidden md:table-cell py-3 px-4">
        <div className="flex items-center gap-2">
          <Tag size={14} className="text-gray-400" />
          <span className="text-gray-600 text-sm">{product.category?.name || '-'}</span>
        </div>
      </td>

      {/* Colonne Ventes - cachée sur tablette */}
      <td className="hidden lg:table-cell py-3 px-4">
        <div className="flex items-center gap-2">
          <Eye size={14} className="text-gray-400" />
          <span className="text-gray-600">{product.soldCount || 0} vendus</span>
        </div>
      </td>
    </TableRow>
  );
}